import { Box, Card, CardContent, Typography } from "@mui/material";
import { useMicrospecThemeLanguageContext } from "../../../Themes";

const SimpleElement = (spec) => {
  const { localizationProvider } = useMicrospecThemeLanguageContext();

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>

      {spec.object ? (
        <Box sx={{
          background: (theme) => theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.02)'
            : 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(20px)',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
        }}>
          {spec.object}
        </Box>
      ) : (
        <Card sx={{
          background: (theme) => theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)'
            : 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 100%)',
          backdropFilter: 'blur(20px)',
          borderRadius: 4,
          border: (theme) => theme.palette.mode === 'dark'
            ? '1px solid rgba(255, 255, 255, 0.1)'
            : '1px solid rgba(255, 255, 255, 0.3)',
          boxShadow: (theme) => theme.palette.mode === 'dark'
            ? '0 8px 32px rgba(0, 0, 0, 0.3)'
            : '0 8px 32px rgba(31, 38, 135, 0.15)',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: (theme) => theme.palette.mode === 'dark'
              ? '0 16px 64px rgba(0, 0, 0, 0.4)'
              : '0 16px 64px rgba(31, 38, 135, 0.2)',
          }
        }}>
          <CardContent sx={{
            p: 4,
            textAlign: 'center',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: (theme) => `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            }
          }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                background: (theme) => theme.palette.mode === 'dark'
                  ? 'linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%)'
                  : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: 'none',
                mb: 2,
              }}
            >
              {localizationProvider.translateByType({
                type: "Internal",
                text: "simpleElementText",
              })}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default SimpleElement;
